import { format } from '@office-start/string-formatter-utility';
import { officeUserSideloadDataCookieKeyFormat } from '../constants/keys';
export const getPrefixedKey = (puid) => {
    return format(officeUserSideloadDataCookieKeyFormat, puid);
};
//# sourceMappingURL=getPrefixedKey.js.map